import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import GoalsFeature from './features/goals';
import InitiationFeature from './features/initiation';
import CustomerStatementFeature from './features/customer-statement';
import CustomerConfirmationFeature from './features/customer-confirmation';
import ConsultantConfirmationFeature from './features/consultant-confirmation';
import { selectIsPrivileged } from '../../../auth/ducks';

function ProtocolFeature() {
  const isPrivileged = useSelector(selectIsPrivileged);

  return (
    <Routes>
      <Route path="goals" element={<GoalsFeature isPrivileged={isPrivileged} />} />
      <Route path="initiation" element={<InitiationFeature isPrivileged={isPrivileged} />} />
      <Route path="customer-statement" element={<CustomerStatementFeature isPrivileged={isPrivileged} />} />
      <Route path="customer-confirmation" element={<CustomerConfirmationFeature isPrivileged={isPrivileged} />} />
      <Route path="consultant-confirmation" element={<ConsultantConfirmationFeature isPrivileged={isPrivileged} />} />
      <Route path="*" element={<Navigate to="../goals" replace />} />
    </Routes>
  );
}

export default ProtocolFeature;
